export const LESSON_DESCRIPTION_CHARACTER_LIMIT: number = 120;

export const lessonDescriptionStyle = {
    margin: 0,
    color: '#33353b',
    fontFamily: 'Arial, Helvetica, sans-serif',
    fontSize: '13px',
    letterSpacing: 0,
    lineHeight: '15px',
}

export enum CourseLessonType {
    VIDEO = "video",
    WEBVIDEO = "web-video",
    AUDIO = "audio",
    PDF = "pdf",
    TEXT = "text",
    EMBED = "embed",
    ASSIGNMENT = "assignment",
    QUIZ = "quiz",
    EVENT = "event",
    FORM = "form",
    WAIVER = "waiver",
}

export enum CourseLessonVisibility {
    ENROLLED = "enrolled",
    HIDDEN = "hidden",
    COMMUNITY = "community",
}

export enum CourseLessonAccess {
    STUDENTS = "students",
    EVENT_ACCESS_LEVEL = "event_access_level",
}

export enum CourseLessonVideoType {
    UPLOAD = "upload",
    URL = "url",
}